import React, { PureComponent } from 'react';
import { Button, ButtonToolbar } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import renderField from '../../../../shared/components/form/TextField';
import renderEditor from '../../../../shared/components/tinymce/TinyMCE';
import validate from '../../validate';

class WizardFormOne extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
  };

  render() {
    const { handleSubmit } = this.props;

    return (
      <form className="form form--horizontal wizard__form wizard__form__lg" onSubmit={handleSubmit}>
        <h3 className="wizard__title">Заполните общею информацию о теме</h3>
        <div className="form__form-group">
          <span className="form__form-group-label">Название темы</span>
          <div className="form__form-group-field">
            <Field name="name" component={renderField} type="text" placeholder="Название темы" />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">Описание в шапке</span>
          <div className="form__form-group-field">
            <Field name="header" component={renderEditor} />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">Описание в списке</span>
          <div className="form__form-group-field">
            <Field name="list" component={renderEditor} />
          </div>
        </div>
        <ButtonToolbar className="form__button-toolbar wizard__toolbar">
          <Button color="primary" type="button" disabled className="previous">
            Предыдущий шаг
          </Button>
          <Button color="primary" type="submit" className="next">
            Следующий шаг
          </Button>
        </ButtonToolbar>
      </form>
    );
  }
}

export default reduxForm({
  form: 'themes_create_form',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(WizardFormOne);
